import { usePunditUserContext } from "@/react/contexts";

export const useIsConnectEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.connect_core_enabled &&
      currentCommunitySettings?.connect_enabled,
  );
};
